import React from "react";
import { useDispatch } from "react-redux";
import { updateOrderAction, fetchOrdersAction } from "../../../redux/slices/orders/ordersSlices";
import Swal from "sweetalert2";

const UpdateOrders = ({ orderId }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState("PENDIENTE");

  const handleChange = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    
    try {
      await dispatch(updateOrderAction({ status: newStatus, id: orderId })).unwrap();
      // Refresh the orders list
      dispatch(fetchOrdersAction());
      
      Swal.fire({
        icon: "success",
        title: "Updated",
        text: `Order status changed to ${newStatus}`,
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error?.message || "Could not update order status",
      });
    }
  };

  return (
    <div className="mt-6 flex items-center space-x-4 divide-x divide-gray-200 border-t border-gray-200 pt-4 text-sm font-medium sm:mt-0 sm:ml-4 sm:border-none sm:pt-0">
      <div className="flex flex-1 justify-center">
        <div>
          <label htmlFor={`status-${orderId}`} className="block text-sm font-medium text-gray-700">
            Update Order
          </label>
          <select
            id={`status-${orderId}`}
            name="status"
            onChange={handleChange}
            value={status}
            className="mt-1 block w-full rounded-md border-2 border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          >
            <option value="PENDIENTE">Pending</option>
            <option value="PROCESANDO">Processing</option>
            <option value="ENVIADO">Shipped</option>
            <option value="ENTREGADO">Delivered</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default UpdateOrders;